import React from 'react';
const Notification = ({ message, isError }) => {
    const displayClasses = ['popupError']
        .concat(isError ? [] : ['popupMessage'])
        .join(' ');
    return (React.createElement("div", { className: "notificationWrap" },
        React.createElement("div", { className: displayClasses }, message)));
};
export default Notification;
